import React from 'react';
import { AspectRatio } from '@yme/atoms/aspect-ratio';
import { AUTO_PLAY, buildQueryParam, getFullSourcePath, getFullSourcePathForPlaylist, VideoPlayer, } from '@yme/atoms/video-player';
import { getYoutubePreview } from '@yme/utils/common';
import { AspectRatio as AspectRatioParams } from '@yme/utils/constants';
import { PreviewVideoImage } from './PreviewVideoImage';
import { DEFAULT_CONFIG_PARAM } from './constants';
export function VideoPlayerHolder(props) {
    const { isPlaying, previewImage, setIsPlaying, autoPlayValue, isPlaylistId, youtubeId } = props;
    const CONFIG_YT_VIDEO = buildQueryParam({
        paramsList: [...DEFAULT_CONFIG_PARAM, `${AUTO_PLAY}=${autoPlayValue}`],
    });
    let youtubeVideoThumbnail;
    if (!isPlaylistId) {
        youtubeVideoThumbnail = {
            src: getYoutubePreview(youtubeId),
        };
    }
    const videoPath = isPlaylistId
        ? getFullSourcePathForPlaylist({
            youtubeId,
            queryParam: CONFIG_YT_VIDEO,
        })
        : getFullSourcePath({
            youtubeId,
            queryParam: CONFIG_YT_VIDEO,
        });
    return (React.createElement(AspectRatio, { ratio: AspectRatioParams.RectangleLevel4 },
        React.createElement(VideoPlayer, { videoPath: videoPath, height: "100%", width: "100%", isPlaying: isPlaying },
            React.createElement(PreviewVideoImage, { isPlaying: isPlaying, previewImage: previewImage || youtubeVideoThumbnail, onClick: () => setIsPlaying(!isPlaying) }))));
}
VideoPlayerHolder.displayName = 'VideoPlayerHolder_Component';
